export default __webpack_public_path__ + "static/media/roads.e5bdd9ab.png";